<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F49W4R/tc-custom/9781609453824.jpg?1728851932262" alt="This image is the cover for the book Ferocity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ferocity
      </h1>
      <p class="bookDescription body article font2">
        <b>This Strega Prize winner “ticks all the boxes of a thriller while also being a masterfully written, baroque, many-faceted depiction of modern Italy” (<i>The Spectator</i>).</b><br/>  <br/> Bari, southern Italy: On a stifling summer night, on the outskirts of town, a young woman named Clara, daughter of the region’s most prominent family of real estate developers, stumbles naked, dazed, and bloodied down a major highway. Her death will be deemed a suicide. Her estranged half-brother, however, cannot free himself from her memory or the questions surrounding her death, and the more he learns about Clara’s life, the more he reveals the moral decay at the core of his family’s ascent to social prominence.<br/>  <br/> Winner of the 2015 Strega Prize, Italy’s preeminent prize for fiction, <i>Ferocity</i> is at once an intimate family saga, a cinematic portrait of the moral and political corruption of an entire society, and a “gripping” tale of suspense (<i>The Irish Times</i>).<br/>  <br/> “Biting social commentary as well as edge-of-seat reading.” —<i>Library Journal</i> (starred review)<br/>  <br/> “Allows the mystery to slowly and captivatingly resolve while offering a layered portrait of contemporary Italian life and the abuses of power that money can excuse.” —<i>Publishers Weekly</i><br/>  <br/> “Complex, darkly absorbing and mysterious literary fiction.” <i>—Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicola Lagioia, Anthony Shugaar
      </h2>
      
      <p class="authorDescription body article">Nicola Lagioia, born in Bari in 1973, is an editor for the Italian publisher Minimum Fax. He is the author of three novels and a collection of short stories. His books have been awarded the Strega Prize, the Premio Volponi, and the Premio Viareggio, among others. He lives in Rome. Ferocity is his English-language debut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46729abe